<template>
  <div class="content">

    <p class="c-red uppercase font-joost">
      Please contact us for any orders or inquiries about our collection.</p>
    <p class="c-red uppercase font-joost">Please email us on <a href="mailto:info@lokomotive.co">info@lokomotive.co</a>
    <br>Headquarters: Sankt Moritz — Switzerland</p>

    <div class="email-form font-joost">
      <form @submit.prevent="submitForm">
        <div>
          <label for="name">*Name:</label>
          <input id="name" type="text" v-model="name" required/>
        </div>
        <div>
          <label for="email">*Email:</label>
          <input id="email" type="email" v-model="email" required/>
        </div>
        <div>
          <label for="email">Phone:</label>
          <input id="phone" type="phone" v-model="phone" required/>
        </div>
        <div>
          <label for="message">Message:</label>
          <input id="phone" v-model="message" required/>
        </div>
        <div class="line my-6"></div>
        <button type="submit">SUBMIT</button>

        <div>
          <p v-if="success"> {{ success }}</p>
          <!--<pre>{{ response }}</pre>-->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      message: '',
      success: null
    }
  },
  methods: {

    submitForm () {
      this.axios.post('http://lokomotive.co/mail.php', {
        name: this.name,
        email: this.email,
        contact: this.phone,
        message: this.message,
        token: 'lokomotive'
      }).then(response => {
        // console.log(response);
        // this.response = response.data
        this.success = 'Email sent, thank you!'
        this.response = JSON.stringify(response, null, 2)
        return true
      }).catch(error => {
        this.response = 'Error: ' + error.response.status
      })
      this.name = ''
      this.email = ''
      this.phone = ''
      this.message = ''
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  p {
    opacity: 0.7;
    font-weight: 600;
    font-size: 20px !important;
    line-height: 1.2;

    @include breakpoint('md-and-down') {
      font-size: 20px !important;
    }

    @include breakpoint('sm-and-down') {
      font-size: 14px !important;
    }
  }
}

.email-form {
  color: $c-red;
}

input {
  border-bottom: 1px solid $c-red;
  padding: 0 5px;
  text-indent: 5px;
  overflow: visible;
}

button {
  padding: 10px;
  background: $c-red;
  color: $c-white;
}
</style>
